import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { FaMapLocationDot } from "react-icons/fa6";
import { ImOffice } from "react-icons/im";
import './ContactUs.css';

export default function ContactUs() {

  
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
  
    const templateParams = {
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };
  
    emailjs.send('service_hfjuhy8', 'template_cv0fu57', templateParams, 'AKDzfoXfa9922wbXV')
      .then((result) => {
        console.log(result.text);
        setStatus('Message sent successfully!');
        setFormData({
          email: '',
          subject: '',
          message: '',
        });
      }, (error) => {
        console.log(error.text);
        setStatus('Failed to send message. Please try again.');
      });
  };
  
  return (
    <section className="section about-us-section full-width">
      <h2 className="section-title-first">Contact Us</h2>

      <div className="contact-cards-container">
        <div className="contact-card">
          <div className="card-icon">
            <FaMapLocationDot size={30} />
          </div>
          <h3>Our Address</h3>
          <p>B 301 New Gokul Heights CHSL, Near Tera Panth Bhawan, Thakur complex, Kandivali(east), Mumbai</p>
        </div>
        <div className="contact-card">
          <div className="card-icon">
            <ImOffice size={30} />
          </div>
          <h3>Office Timing</h3>
          <p>Mon To Sat - 10.00AM- 07.00PM</p>
        </div>
        <div className="contact-card">
          <div className="card-icon">
            <FaEnvelope size={30} />
          </div>
          <h3>Our Email</h3>
          <a href="mailto:info@databoltahai.in">
            <p>info@databoltahai.in</p>
          </a>
        </div>
        <div className="contact-card">
          <div className="card-icon">
            <FaPhoneAlt size={30} />
          </div>
          <h3>Our Phone</h3>
          <a href="tel:+9170215-20017">
            <p>+91 70215-20017</p>
          </a>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form-section">
        <h3>Send Us a Message</h3>

        {/* Display success or error message */}
        {status && <p className="status-message">{status}</p>}

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>

          <button type="submit">Send Message</button>
        </form>
      </div>

      {/* Embedded Google Map */}
      <div className="map-container">
        <h3>Find Us on Google Maps</h3>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.611878030617!2d72.86276546980388!3d19.2121472079737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7309348dd09%3A0x4c489bd3db40ad5c!2sDimple%20Arcade%2C%20Asha%20Nagar%20Rd%2C%20Kandivali%2C%20Gayatri%20Nagar%2C%20Asha%20Nagar%2C%20Kandivali%20East%2C%20Mumbai%2C%20Maharashtra%20400101!5e0!3m2!1sen!2sin!4v1738905446397!5m2!1sen!2sin"
          width="100%"
          height="500"
          style={{ border: "0", borderRadius: "20px" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </section>
  );
}
